<template>
  <div class="gewerbe-immobilien">
    <div v-for="(immobilie, index) in immobilien"
              :key="'immobilie_' + immobilie.key">
      <div :class="{ 'mt-4': index > 0 && isWohnung, 'mt-6': index > 0 && !isWohnung }"
           class="we--ueber mb-4">
        <div class="secondary--text subueber">{{ isWohnung ? 'Wohneinheit' : 'Immobilie' }} {{ index + 1 }}</div>
        <div class="secondary--text">{{ subtitle(immobilie) }} </div>
      </div>
      <address-data :state-path="immobilie.statePath"
                    :staat-disabled="staatDisabled"></address-data>
    </div>
  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import AddressData from './AddressData';
import immobilienConfig from '../../store/config/immobilie';
import keyTranslatorMixin from '@/components/helper/keyTranslatorMixin';
import { mapTwoWay } from '@/store/twowayBindingMixin';
import twowayBinding from '@/store/twowayBindingMixin';
import { mapState } from 'vuex';
  
export default {
  components: { AddressData },
  mixins: [ValidationMixin, twowayBinding, keyTranslatorMixin],
  props: {
    staatDisabled: {
      type: Boolean,
      default: false
    },
    immobilien: {
      type: Array,
      required: true
    },
    isWohnung: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      objektArten: immobilienConfig.art.reduce((a,b) => a.concat(b))
    };
  },
  computed: {
    ...mapTwoWay(['vertrag'],{} , 'gewerbe'),
    ...mapState({
      deckungen: state => state.gewerbe.deckungen
    }),
    inKOMPEX() {
      return this.deckungen.some(d => d.produkt === 'MIETZ');
    }
  },
  methods: {
    subtitle(immobilie) {
      let text = '';
      if (this.isWohnung) {
        text = `Jahresbruttomiete ${this.$helpers.toGermanIntegerString(immobilie.bruttojahresmiete)} €`;
      } else {
        text = `${this.immobilieArt(immobilie.art)}, ${immobilie.bezug}, ${this.$helpers.toGermanIntegerString(immobilie.value)} ${this.inKOMPEX ? '€ Jahresbruttopacht' : immobilienConfig.errortext[immobilie.art]}`;
      }
      return`${text}, ${this.praemienName('' + this.vertrag.zahlweise)}: ${this.$helpers.toGermanFloatString(this.immobiliePraemie(immobilie.key))} €`;
    },
    immobiliePraemie(key) {
      let deckung;
      if (this.isWohnung) {
        deckung = this.deckungen.find(d => d.produkt === 'SPEZ-PRIVVM' && d.wohnRef === key);
      } else {
        deckung = this.deckungen.find(d => d.produkt === 'MIET' && d.immoRef === key);
        if (!deckung) deckung = this.deckungen.find(d => d.produkt === 'MIETZ' && d.immoRef === key);
      }
      return deckung ? deckung.praemie[`z${this.vertrag.zahlweise}`] : 0;
    },
    immobilieArt(value) {
      const art = this.objektArten.find(a => a.value === value);
      return art ? art.text : '';
    }
  }
};
</script>

<style>
</style>

